module.exports = __webpack_public_path__ + "static/media/hse-recruitment-logo.b2a888e6.png";